<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Price.LCLFreightDetails')"
    width="990px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view lcl-form"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px">
        <el-button no="onSubmit" type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
      <div style="width: fit-content">
        <div style="display: flex">
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.PriceNo')">
                <el-input
                  no="priceNo"
                  :value="price.priceNo"
                  :disabled="true"
                />
              </el-form-item>
              <el-form-item ref="pol" required :label="$t('Pricing.POL')">
                <cargo-advance-select
                  no="pol"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.pol"
                  filterable
                  @parentCallBack="p=>{price.pol=p.value}"
                />
              </el-form-item>
              <el-form-item ref="pod" required :label="$t('Pricing.POD')">
                <cargo-advance-select
                  no="pod"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.pod"
                  filterable
                  @parentCallBack="p=>{price.pod=p.value}"
                />
              </el-form-item>
              <el-form-item label=" ">
                <el-checkbox v-model="price.direct" no="direct" :label="$t('Pricing.Direct')" />
              </el-form-item>
              <el-form-item v-if="!price.direct" ref="via" :required="true" :label="$t('Pricing.Via')">
                <cargo-advance-select
                  no="via"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.via"
                  filterable
                  @parentCallBack="p=>{price.via=p.value}"
                />
              </el-form-item>
              <el-form-item ref="term" required :label="$t('Pricing.PaymentTerm')">
                <cargo-advance-select
                  no="term"
                  :select-type="selectTypeNames.local_cache_PriceConstant$PAYMENT_TERMS"
                  :show-custom-label-in-option="true"
                  :default-value="price.term"
                  @parentCallBack="p=>{price.term=p.value}"
                />
              </el-form-item>
              <el-form-item ref="carrier" required :label="$t('Pricing.Carrier')">
                <cargo-advance-select
                  no="carrier"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.carrier"
                  @parentCallBack="p=>{price.carrier=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item ref="bookingAgent" required :label="$t('Pricing.Source')">
                <cargo-advance-select
                  no="bookingAgent"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{bookingAgent:true}"
                  :custom-label="(item)=>`${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.bookingAgent"
                  @parentCallBack="p=>{price.bookingAgent=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.RateGrade')">
                <rate-grade
                  no="gradeUnit"
                  :grade-min="price.gradeMin"
                  :grade-max="price.gradeMax"
                  :grade-unit="price.gradeUnit"
                  :show-unit="true"
                  @onChangeMin="p=>{price.gradeMin=p}"
                  @onChangeMax="p=>{price.gradeMax=p}"
                  @onChangeUnit="p=>{price.gradeUnit=p}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ShippingLine')">
                <el-input
                  v-model="price.shippingLine"
                  no="shippingLine"
                  :maxlength="16"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ContractNo')">
                <el-input
                  v-model="price.contractNo"
                  no="contractNo"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.CabinNature')">
                <cargo-advance-select
                  no="share"
                  :select-type="selectTypeNames.local_cache_PriceConstant$CABIN_NATURE"
                  :show-custom-label-in-option="true"
                  :default-value="price.share"
                  @parentCallBack="p=>{price.share=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ShareCarriers')" prop="shareCarrier">
                <div style="display: flex">
                  <cargo-advance-select
                    no="carrier"
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{seaCmp:true}"
                    filterable
                    :default-value="share.carrier"
                    :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                    :show-custom-label-in-option="true"
                    tag-value="cmpIdx"
                    style="flex: 1"
                    @parentCallBack="item=>share.carrier=item.value"
                  />
                  <span class="form-operator" @click="onPriceSubscribeFormAdd('carrier')"><i class="el-icon-circle-plus" /></span>
                  <span class="form-operator" @click="onPriceSubscribeFormRemove('carrier')"><i class="el-icon-remove" /></span>
                </div>
              </el-form-item>
              <el-form-item class="custom" prop="shareCarrierCodes">
                <el-checkbox-group v-model="share.carrierCodes" no="carrierCodes">
                  <el-col
                    v-for="code in carrierCheckBoxGroup"
                    :key="code"
                    :span="8"
                  >
                    <el-checkbox no="carrierCode" :label="code" :title="code">{{ resolveColumnLabel(selectTypeNames.basic_data_Company, 'cmpIdx', Number(code), 'shortName') }}</el-checkbox>
                  </el-col>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item :label="$t('Pricing.TransportMode')">
                <cargo-advance-select
                  no="transportMode"
                  filterable
                  :select-type="selectTypeNames.basic_data_ShippingTerm"
                  :placeholder="$t('Pricing.PlsSelect')"
                  :multiple="true"
                  :default-multiple-value="price.transportMode"
                  tag-value="name"
                  @parentCallBack="p=>{price.transportMode=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.SubContractNo')">
                <el-input
                  v-model="price.subContractNo"
                  no="subContractNo"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.NA')">
                <el-input
                  v-model="price.na"
                  no="na"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.NaCode')">
                <el-input
                  v-model="price.naCode"
                  no="naCode"
                  :maxlength="32"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column" style="min-width: 340px">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item ref="currency" required :label="$t('Pricing.Currency')">
                <cargo-advance-select
                  no="currency"
                  :select-type="selectTypeNames.basic_data_Currency"
                  :clearable="false"
                  :default-value="price.currency"
                  @parentCallBack="p=>{price.currency=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.COST_VAT')">
                <div style="display: flex">
                  <el-input
                    v-model="costVat"
                    no="costVat"
                    type="number"
                    style="width: 100%"
                    @change="costVatChange"
                  />
                  <label> %</label>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.SELL_VAT')">
                <div style="display: flex">
                  <el-input
                    v-model="sellVat"
                    no="sellVat"
                    type="number"
                    style="width: 100%"
                    @change="sellVatChange"
                  />
                  <label> %</label>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.DestinationDock')">
                <el-input
                  v-model="price.destinationDock"
                  no="destinationDock"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.CostPrice') + '(COST)'">
                <pair-numeric-stepper
                  no="costWeightPrice"
                  :one="price.costWeightPrice"
                  :two="price.costVolumePrice"
                  :three="price.minimumTonCost"
                  :show-three="true"
                  :one-prompt="$t('Pricing.CostPrice')"
                  :two-prompt="$t('Pricing.VolumePrice')"
                  :three-prompt="$t('Pricing.MinimumPrice')"
                  @onChangeOne="p=>{price.costWeightPrice=p}"
                  @onChangeTwo="p=>{price.costVolumePrice=p}"
                  @onChangeThree="p=>{price.minimumTonCost=p}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ColoaderPrice') + '(T1)'">
                <pair-numeric-stepper
                  no="oneWeightPrice"
                  :one="price.oneWeightPrice"
                  :two="price.oneVolumePrice"
                  :three="price.minimumTonPrice1"
                  :show-three="true"
                  :one-prompt="$t('Pricing.CostPrice')"
                  :two-prompt="$t('Pricing.VolumePrice')"
                  :three-prompt="$t('Pricing.MinimumPrice')"
                  @onChangeOne="p=>{price.oneWeightPrice=p}"
                  @onChangeTwo="p=>{price.oneVolumePrice=p}"
                  @onChangeThree="p=>{price.minimumTonPrice1=p}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.CustomerPrice') + '(T2)'">
                <pair-numeric-stepper
                  no="twoWeightPrice"
                  :one="price.twoWeightPrice"
                  :two="price.twoVolumePrice"
                  :three="price.minimumTonPrice2"
                  :show-three="true"
                  :one-prompt="$t('Pricing.CostPrice')"
                  :two-prompt="$t('Pricing.VolumePrice')"
                  :three-prompt="$t('Pricing.MinimumPrice')"
                  @onChangeOne="p=>{price.twoWeightPrice=p}"
                  @onChangeTwo="p=>{price.twoVolumePrice=p}"
                  @onChangeThree="p=>{price.minimumTonPrice2=p}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.MarketPrice') + '(T3)'">
                <pair-numeric-stepper
                  no="threeWeightPrice"
                  :one="price.threeWeightPrice"
                  :two="price.threeVolumePrice"
                  :three="price.minimumTonPrice3"
                  :show-three="true"
                  :one-prompt="$t('Pricing.CostPrice')"
                  :two-prompt="$t('Pricing.VolumePrice')"
                  :three-prompt="$t('Pricing.MinimumPrice')"
                  @onChangeOne="p=>{price.threeWeightPrice=p}"
                  @onChangeTwo="p=>{price.threeVolumePrice=p}"
                  @onChangeThree="p=>{price.minimumTonPrice3=p}"
                />
              </el-form-item>
              <el-form-item ref="isFrequency" required :label="$t('Pricing.DepartureDay')">
                <el-input
                  no="isFrequency"
                  :disabled="true"
                  :value="isFrequency"
                />
              </el-form-item>
              <div style="display: flex;">
                <el-checkbox v-model="price.frequency1" no="frequency1" :label="1" style="margin-right: 12px;width: 100%" />
                <el-checkbox v-model="price.frequency2" no="frequency2" :label="2" style="margin-right: 12px;width: 100%" />
                <el-checkbox v-model="price.frequency3" no="frequency3" :label="3" style="margin-right: 12px;width: 100%" />
                <el-checkbox v-model="price.frequency4" no="frequency4" :label="4" style="margin-right: 12px;width: 100%" />
                <el-checkbox v-model="price.frequency5" no="frequency5" :label="5" style="margin-right: 12px;width: 100%" />
                <el-checkbox v-model="price.frequency6" no="frequency6" :label="6" style="margin-right: 12px;width: 100%" />
                <el-checkbox v-model="price.frequency7" no="frequency7" :label="7" style="margin-right: 12px;width: 100%" />
              </div>
              <el-form-item :label="$t('Pricing.ClosingDay')">
                <el-input
                  no="closingDay"
                  :disabled="true"
                  :value="price.closingDay"
                />
              </el-form-item>
              <el-checkbox-group v-model="closingDay">
                <el-col
                  v-for="code in frequencys"
                  :key="code"
                  style="width: 14%;"
                >
                  <el-checkbox no="closingDay" :label="code" />
                </el-col>
              </el-checkbox-group>
              <el-form-item ref="days" :required="true" :label="$t('Pricing.DaysUnitSea')">
                <el-input
                  v-model="price.days"
                  no="days"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item required :label="$t('Pricing.volumeWeightRatio')">
                <cargo-advance-select
                  no="volumeWeightRatio"
                  :select-type="selectTypeNames.local_cache_SystemConstants$VOLUME_WEIGHT_RATIO"
                  :custom-label="item=>item.name"
                  :show-custom-label-in-option="true"
                  :clearable="true"
                  :default-value="price.volumeWeightRatio"
                  @parentCallBack="p=>{price.volumeWeightRatio=p.value}"
                />
              </el-form-item>
              <el-form-item ref="minRateValue" :label="$t('Pricing.minRateValue')">
                <div style="display:flex;">
                  <el-input
                    v-show="price.minRateUnit !== '最低价'"
                    v-model="price.minRateValue"
                    style="width:140px;"
                    :placeholder="$t('Pricing.PleaseNumber')"
                    no="minRateValue"
                  />
                  <cargo-advance-select
                    no="minRateUnit"
                    :select-type="selectTypeNames.local_cache_ChargeUnit"
                    :clearable="false"
                    :default-value="price.minRateUnit"
                    @parentCallBack="p=>{price.minRateUnit=p.code;price.minRateValue=0}"
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.DestinationAgent')">
                <div :title="destinationAgentTitle">
                  <cargo-advance-select
                    no="destinationAgent"
                    filterable
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{designationAgent:true}"
                    :show-custom-label-in-option="true"
                    :multiple="true"
                    style="width: 100%"
                    :default-multiple-value="price.destinationAgent"
                    @parentCallBack="p=>{price.destinationAgent=p.value}"
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.priceNature')">
                <cargo-advance-select
                  no="priceNature"
                  :select-type="selectTypeNames.local_cache_PriceConstant$PRICE_NATURE"
                  :show-custom-label-in-option="true"
                  :default-value="price.priceNature"
                  @parentCallBack="p=>{price.priceNature=p.value}"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item
                :label="$t('SeaExport.WarehouseSupplier')"
              >
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Company"
                  filterable
                  :default-value="price.warehouseVendorCmpIdx||''"
                  tag-name="chineseName"
                  style="width:100%;"
                  :method-params="{warehouse:true}"
                  @parentCallBack="warehouseCmpChangeHandler"
                />
              </el-form-item>
              <el-form-item
                :label="$t('SeaExport.WareHouseName')"
              >
                <el-select
                  v-model="price.warehouseUuid"
                  no="warehouseUuid"
                  :allow-create="true"
                  filterable
                  :clearable="true"
                >
                  <el-option
                    v-for="(item,index) in warehouseNameList"
                    :key="index"
                    :label="item.warehouseName || ' ' "
                    :value="item.uuid"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Pricing.PriceState')">
                <cargo-advance-select
                  no="priceState"
                  :select-type="selectTypeNames.local_cache_PriceConstant$PRICE_STATE"
                  :show-custom-label-in-option="true"
                  :default-value="price.priceState"
                  :clearable="false"
                  @parentCallBack="p=>{price.priceState=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.PriceTrend')">
                <el-radio-group v-model="price.trend" no="trend" style="display: flex; margin-top: 3px">
                  <el-radio no="rise" :label="1">{{ $t('Pricing.Rise') }}</el-radio>
                  <el-radio no="fair" :label="0">{{ $t('Pricing.Fair') }}</el-radio>
                  <el-radio no="fall" :label="-1">{{ $t('Pricing.Fall') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item ref="beginDate" required :label="$t('Pricing.BeginDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.beginDate"
                    no="beginDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item ref="endDate" required :label="$t('Pricing.EndDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.endDate"
                    no="endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.Remarks')">
                <cargo-rich-textarea
                  v-model="price.remarks"
                  no="remarks"
                  :text-chars="0"
                  style="min-height: 80px"
                  :warning-count="-1"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),price.remarks,val=>{price.remarks=val})"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogValue"
        :disabled="readonly"
        :required="false"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        style="height: 198px;"
      />
      <span slot="footer">
        <el-button
          v-show="!readonly"
          no="finishAdvanceText"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import NumericStepper from '@/views/cargo/v0/Price/components/numericStepper'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { savePriceLcl } from '@/api/price/priceLcl'
import RateGrade from '@/views/cargo/v0/Price/components/rateGrade'
import ColumnUtils from '@/utils/ColumnUtils'
import PairNumericStepper from '@/views/cargo/v0/Price/components/pairNumericStepper'
import URL from '@/api/urlTranslator'
import { getWarehouseDetail } from '@/api/company'

export default {
  name: 'LclForm',
  components: {
    PairNumericStepper,
    RateGrade, CargoAgGrid, cargoAdvanceSelect, NumericStepper,
    cargoRichTextarea
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    price: {
      type: Object,
      default: () => ({})
    },
    isCp: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      resolveColumnLabel: ColumnUtils.resolveColumnLabel,
      frequencys: PriceUtils.FREQUENCYS,
      costVat: null,
      sellVat: null,
      warehouseNameList: [],
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0
        }
      },
      share: {
        carrierCodes: [],
        carrier: ''
      }
    }
  },
  computed: {
    destinationAgentTitle() {
      let destinationAgent = this.price.destinationAgent
      if (Array.isArray(destinationAgent)) {
        destinationAgent = this.price.destinationAgent.join(',')
      }
      return ColumnUtils.moreCompanyLabelFun(destinationAgent, 'englishName', 'cmpIdx')
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    closingDay: {
      get() {
        return StrUtils.isEmpty(this.price.closingDay) ? [] : this.price.closingDay.split(',')
      },
      set(val) {
        this.price.closingDay = val.join(',')
      }
    },
    isFrequency() {
      const FREQUENCYS = PriceUtils.FREQUENCYS
      const arr = []
      for (const field of FREQUENCYS) {
        if (this.price['frequency' + field]) {
          arr.push(field)
        }
      }
      return arr.join('/')
    },
    isZh() {
      return this.$store.getters.language
    },
    carrierCheckBoxGroup: {
      get() {
        if (StrUtils.isEmpty(this.price.shareCarrier)) {
          return []
        }
        return this.price.shareCarrier.split(',').filter(item => !StrUtils.isEmpty(item))
      },
      set(val) {
        this.price.shareCarrier = val.join(',')
      }
    }
  },
  watch: {
    'price.minRateUnit': {
      handler(value) {
        if (value === '最低价') {
          this.price.minRateValue = ''
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.closingDay = StrUtils.isEmpty(this.price.closingDay) ? [] : this.price.closingDay.split(',')
    if (this.price.costVat) {
      this.costVat = this.$numeral(this.price.costVat).format('0.000')
    }
    if (this.price.sellVat) {
      this.sellVat = this.$numeral(this.price.sellVat).format('0.000')
    }
  },
  mounted() {
    this.warehouseCmpChangeHandler(this.price, false)
  },
  methods: {
    onSubmit() {
      if (this.verifyForm()) {
        return
      }
      if (this.verifySame('pol', 'pod')) {
        return
      }
      if (!this.price.direct) {
        if (!StrUtils.isEmpty(this.price.via)) {
          if (this.verifySame('via', 'pol')) {
            return
          }
          if (this.verifySame('via', 'pod')) {
            return
          }
        } else {
          const label = this.$refs['via'].label
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return
        }
      } else {
        this.price.via = ''
      }
      if (StrUtils.isEmpty(this.price.term)) {
        this.$message.warning(this.$t('Pricing.SelectTerm'))
        return
      }
      if (this.price.sellVat < this.price.costVat) {
        this.$message.warning(this.$t('Pricing.VatInvalid'))
        return
      }
      if (StrUtils.isEmpty(this.price.closingDay)) {
        this.$message.warning(this.$t('Pricing.ClosingDay') + this.$t('Pricing.WrongInput'))
        return
      }

      if (this.price.closingDay.length > 0 && this.price.closingDay.length !== this.isFrequency.length) {
        const message = this.$t('Pricing.NotSameLength')
        const closingDay = this.$t('Pricing.ClosingDay')
        const departureDay = this.$t('Pricing.DepartureDay')
        this.$message.warning(message.replace('{0}', closingDay).replace('{1}', departureDay))
        return
      }
      if (StrUtils.isEmpty(this.price.days)) {
        this.$message.warning(this.$t('Pricing.DaysUnitSea') + this.$t('Pricing.WrongInput'))
        return
      }
      if (!this.isDaysValid()) {
        return
      }
      if (this.price.beginDate > this.price.endDate) {
        this.$message.warning(this.$t('Pricing.CompareValidate'))
        return
      }
      if (StrUtils.isEmpty(this.price.transportMode) || this.price.transportMode.length === 0) {
        this.$message.warning(this.$t('Pricing.SelectTransportMode'))
        return
      }
      if (StrUtils.isEmpty(this.price.volumeWeightRatio)) {
        this.$message.warning(this.$t('Pricing.ErrorVolumeWeightRatio'))
        return
      }
      this.price.receivingType = StrUtils.isEmpty(this.price.receivingInstructions) ? 0 : 1
      this.price.modifiedBy = this.$store.getters.userId
      this.price.dateModified = new Date()
      this.price.branchId = this.$store.getters.currentOfficeId
      this.setDefaultValue('customSpecs', 'via')
      this.save()
    },
    save() {
      if (!this.isNew) {
        if (this.price.state === 1) {
          this.price.state = 0
          this.price.isActive = false
          this.price.dateEffective = null
          this.price.dateApproved = null
          this.price.approvedBy = 0
          this.price.priceNo = ''
          this.deleteCp(this.price)
        }
        // 修改已发布运价后, 移除原有记录--去除该功能
      }
      this.fullscreenLoading = getLoading()
      const price = this.price
      if (this.price.oldUuid) {
        delete price['oldUuid']
        delete price['uuid']
      }
      const newPrice = { ...price }
      newPrice.destinationAgent = newPrice.destinationAgent.join(',')
      newPrice.transportMode = newPrice.transportMode.join(',')
      savePriceLcl(newPrice).then((res) => {
        if (this.isNew) {
          this.$message.success(this.$t('Pricing.SavedSucceed'))
        } else {
          if (this.isCp) {
            this.$message.success(this.$t('Pricing.CurrentPriceEditSucceed'))
          } else {
            this.$message.success(this.$t('Pricing.SavedSucceed'))
          }
        }
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 修改已发布运价后, 移除原有记录
    deleteCp(data) {
      const params = []
      params.push(data)
      this.$emit('deleteCp', params)
    },
    setDefaultValue(...fields) {
      fields.forEach(item => {
        if (!this.price[item]) {
          this.price[item] = ''
        }
      })
    },
    verifyForm() {
      for (const ref in this.$refs) {
        if (this.$refs[ref].isRequired && this.verifyField(ref)) {
          const label = this.$refs[ref].label
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return true
        }
      }
    },
    verifyField(field) {
      if (field === 'isFrequency') {
        return StrUtils.isEmpty(this.isFrequency)
      }
      if (typeof this.price[field] === 'number') {
        return this.price[field] === 0
      }
      return StrUtils.isEmpty(this.price[field])
    },
    verifySame(field1, field2) {
      if (this.price[field1] === this.price[field2]) {
        const label1 = this.$refs[field1].label
        const label2 = this.$refs[field2].label
        const message = this.$t('Pricing.MustDifferent')
        this.$message.warning(message.replace('{0}', label1).replace('{1}', label2))
        return true
      }
      return false
    },
    onCancel() {
      this.$emit('close')
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    costVatChange(newVal) {
      const val = Number(newVal)
      if (!val || val < 0) {
        this.costVat = null
        this.price.costVat = 0
        return
      }
      const formatNumber = this.$numeral(val).format('0.000')
      this.price.costVat = formatNumber
      this.costVat = formatNumber
    },
    sellVatChange(newVal) {
      const val = Number(newVal)
      if (!val || val < 0) {
        this.sellVat = null
        this.price.sellVat = 0
        return
      }
      const formatNumber = this.$numeral(val).format('0.000')
      this.price.sellVat = formatNumber
      this.sellVat = formatNumber
    },
    onPriceSubscribeFormAdd(type) {
      const code = this.share[`${type}`]
      if (code) {
        if (this[`${type}CheckBoxGroup`].indexOf(code) === -1) {
          const newCheckBoxGroup = [...this[`${type}CheckBoxGroup`], code]
          this[`${type}CheckBoxGroup`] = newCheckBoxGroup
          this.share[`${type}`] = ''
        }
      } else {
        const code = this[`${type}CheckBoxGroup`][this[`${type}CheckBoxGroup`].length - 1]
        this.share[`${type}Codes`] = [...this.share[`${type}Codes`], code]
      }
    },
    onPriceSubscribeFormRemove(type) {
      this[`${type}CheckBoxGroup`] = this[`${type}CheckBoxGroup`].filter(code => this.share[`${type}Codes`].indexOf(code) === -1)
      this.share[`${type}Codes`] = this.share[`${type}Codes`].filter(code => this[`${type}CheckBoxGroup`].indexOf(code) !== -1)
    },
    isDaysValid() {
      const days = this.price.days.trim().split('-')
      if (days.length > 2) {
        this.$message.warning(this.$t('Pricing.BadDays'))
        return false
      }
      if (days.length === 2) {
        const daysMin = Number(days[0])
        const daysMax = Number(days[1])
        if (isNaN(daysMin) || isNaN(daysMax) || daysMin > daysMax) {
          this.$message.warning(this.$t('Pricing.BadDays'))
          return false
        }
      }
      if (isNaN(Number(days[0]))) {
        this.$message.warning(this.$t('Pricing.BadDays'))
        return false
      }
      if (days[0] && Number(days[0]) < 0) {
        this.$message.warning(this.$t('Pricing.GreaterThanZero'))
        return false
      }
      return true
    },
    /**
     * 获取仓库供应商下的仓库列表
     * @param params
     * @param isSelect 是否为仓库供应商下拉框选中触发
     */
    warehouseCmpChangeHandler(params, isSelect = true) {
      let uuid = ''
      if (isSelect) {
        this.$emit('supplierChange', params)
        uuid = params.uuid
      } else {
        uuid = params.warehouseVendorUuid
      }
      if (!uuid) return
      this.warehouseNameList = []
      getWarehouseDetail(uuid).then(res => {
        console.log(res)
        this.warehouseNameList = Array.isArray(res.data) ? res.data : []
      })
    }
  }
}
</script>

<style lang="scss">
  @import "~@/styles/element-variables.scss";
  .lcl-form{
    .el-radio-group{
      margin-bottom: 8px;
      margin-top: 8px;
    }
    .el-radio{
      margin-right: 10px;
    }
    .el-textarea__inner{
      min-height: 100px !important;
    }
    .form-operator{
      margin-left: 5px;
      cursor: pointer;
      font-size: 18px;
      .el-icon-circle-plus{
        color: $--color-success;
      }
      .el-icon-remove
      {
        color: $--color-danger;
      }
    }
  }
</style>
